import {FetchError, type FetchOptions} from "ofetch";

interface ApiResponse<T> {
    success: boolean
    message: string
    data: T
    errors?: any[]
}
type ApiStatus = 'idle' | 'pending' | 'success' | 'error'

export async function useApi<T>(url: string, options?: FetchOptions){
    const { $api } = useNuxtApp()

    // ssr false
    const data = ref<ApiResponse<T>>()
    const error = ref<any>(undefined)
    const status = ref<ApiStatus>('idle')

    const isNetworkError = (e: any) => {
        if (e?.name === 'FetchError' && !e.response) return true
        if (e instanceof TypeError && e.message === 'Failed to fetch') return true
        if (typeof e?.message === 'string' && (e.message.includes('Failed to fetch') || e.message.includes('NetworkError') || e.message.includes('Load failed'))) return true
        return false
    }

    const execute = async () => {
        status.value = 'pending';
        error.value =undefined
        try {
            data.value = await $api<T>(url, options as any)
            status.value = 'success';
        } catch (e: any) {
            const err = e as FetchError
            status.value = 'error';

            if (isNetworkError(e)) {
                error.value = {
                    errors: { _network: ['مشکل در اتصال. لطفاً اینترنت را بررسی کنید.'] },
                }
                return
            }

            error.value = err?.data
        }
    }

    await execute();


    return {
        data: data,
        error: error,
        status: status,
        refresh: execute
    }
}